import { render, staticRenderFns } from "./ClientForm_48.vue?vue&type=template&id=783df971&scoped=true"
import script from "./ClientForm_48.ts?vue&type=script&lang=ts&external"
export * from "./ClientForm_48.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783df971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783df971')) {
      api.createRecord('783df971', component.options)
    } else {
      api.reload('783df971', component.options)
    }
    module.hot.accept("./ClientForm_48.vue?vue&type=template&id=783df971&scoped=true", function () {
      api.rerender('783df971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ClientForm_48/ClientForm_48.vue"
export default component.exports